<div class="container-fluid mt-3">
  <!-- Loading -->
  <div *ngIf="loading" class="text-center py-5">
    <i class="fa fa-spinner fa-spin fa-2x"></i>
    <p class="mt-2 text-muted">Loading packet...</p>
  </div>

  <!-- Error -->
  <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

  <!-- Packet Detail -->
  <div *ngIf="packet && !loading">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-start mb-3">
      <div>
        <h4 class="mb-0">{{ packet.candidateName }} - {{ getWorkflowDisplayName(packet.workflowType) }}</h4>
        <div *ngIf="positionDisplay" class="text-muted" style="font-size: 0.9rem;">
          {{ positionDisplay }}
        </div>
        <div class="text-muted mt-1" style="font-size: 0.9rem;">
          Program Year &raquo; {{ formatYear(packet.periodOfReviewId) }}
        </div>
        <div class="text-muted" style="font-size: 0.9rem;">
          Period Of Review &raquo; {{ extractDateFromUtcString(packet.periodOfReviewStartDate) | date:'mediumDate' }} - {{ extractDateFromUtcString(packet.periodOfReviewEndDate) | date:'mediumDate' }}
        </div>
        <div class="text-muted" style="font-size: 0.9rem;">
            Case #{{ packet.caseId }} &middot; Created {{ packet.createdAt | date:'mediumDate' }}
        </div>
      </div>
      <div class="text-right">
        <span class="badge" [ngClass]="getCaseStatusClass(packet.status)">
          {{ packet.status }}
        </span>
        <div *ngIf="packet.result" class="text-muted mt-1" style="font-size: 0.85rem;">
          {{ packet.result }}
        </div>
      </div>
    </div>

    <!-- Progress Bar -->
    <stage-stepper class="d-block mb-4" [steps]="stageSteps"></stage-stepper>

    <!-- Tasks Timeline -->
    <div class="card mb-3">
      <div class="card-header">
        <strong>Tasks</strong>
      </div>
      <div class="card-body p-0">
        <table class="table table-sm mb-0">
          <thead class="thead-light">
            <tr>
              <th>Stage</th>
              <th>Assigned To</th>
              <th>Status</th>
              <th>Created</th>
              <th>Due Date</th>
              <th>Completed</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let task of packet.tasks" style="height: 2.5rem;">
              <td>{{ getStageName(task.stage) }}</td>
              <td>{{ task.assignedToName || task.assignedToEmail || '—' }}</td>
              <td>
                <span class="badge" [ngClass]="getDisplayTaskStatusClass(task)">{{ getDisplayTaskStatus(task) }}</span>
              </td>
              <td>{{ task.createdAt | date:'mediumDate' }}</td>
              <td>{{ task.dueDate | date:'mediumDate' }}</td>
              <td>{{ task.completedAt | date:'mediumDate' }}</td>
              <td class="text-right">
                <button *ngIf="task.status !== 'Cancelled' && task.showTaskDetails" class="btn btn-sm btn-outline-primary" (click)="openTask(task)">
                  {{ task.status === 'Completed' ? 'View' : 'Open' }}
                </button>
              </td>
            </tr>
            <tr *ngIf="packet.tasks.length === 0">
              <td colspan="7" class="text-center text-muted py-3">No tasks yet</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Attachments grouped by stage -->
    <div class="card mb-3" *ngIf="attachmentGroups.length > 0">
      <div class="card-header">
        <strong>Attachments</strong>
      </div>
      <div class="card-body p-0">
        <div *ngFor="let group of attachmentGroups" class="attachment-stage-group">
          <div class="attachment-stage-header px-3 py-2" *ngIf="group.stageLabel">
            <strong>{{ group.stageLabel }}</strong>
          </div>
          <div *ngFor="let slot of group.slots" class="attachment-slot-group">
            <div class="attachment-slot-label px-3 py-1 text-muted" *ngIf="slot.documentSlot">
              <i class="fa fa-folder-open-o mr-1"></i>{{ slot.documentSlot }}
            </div>
            <ul class="list-group list-group-flush">
              <li *ngFor="let att of slot.attachments"
                  class="list-group-item d-flex align-items-center pl-4">
                <i class="fa fa-file mr-2 text-muted"></i>
                <button type="button"
                  class="btn btn-sm btn-primary mr-1"
                  style="padding: 0 0.2rem;"
                  (click)="viewAttachment(att)">View</button>
                <button type="button"
                  class="btn btn-sm btn-success mr-2"
                  style="padding: 0 0.2rem;"
                  (click)="downloadAttachment(att)">Download</button>
                <span>{{ att.fileName }}</span>
                <small class="text-muted ml-2">({{ ((att.sizeBytes || 0) / 1024) | number:'1.0-0' }} KB)</small>
                <small class="text-muted ml-auto">{{ att.uploadedAt | date:'mediumDate' }}</small>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Per-case review-date overrides (renders for AHR admins only).
         Positioned at the bottom, below documents. -->
    <case-review-date-overrides
        [caseId]="packet.caseId"
        [periodOfReviewId]="packet.periodOfReviewId">
    </case-review-date-overrides>
  </div>
</div>
